import { StyleSheet } from 'react-native-unistyles';
import Box from '@/components/Unistyles/Box';
import Icon from '@/components/Unistyles/Icon';
import Pressable from '@/components/Unistyles/Pressable';
import TextInput from '@/components/Unistyles/TextInput';
import getOffsetColor from '@/utils/getOffsetColor';
import { selectionAsync } from '@/utils/Haptics';
import palette from '@/utils/palette';
import FieldCard from './FieldCard';

type TitleColorFieldsProps = {
  autoFocus?: boolean;
  color: string;
  onChangeColor(color: string): void;
  onChangeTitle(title: string): void;
  placeholder: string;
  title: string;
};

export default function TitleColorFields({
  autoFocus = false,
  color,
  onChangeColor,
  onChangeTitle,
  placeholder,
  title,
}: TitleColorFieldsProps) {
  const selectedColor = color || palette[0];

  return (
    <FieldCard>
      <TextInput
        autoCapitalize="words"
        autoFocus={autoFocus}
        enterKeyHint="done"
        placeholder={placeholder}
        value={title}
        onChangeText={onChangeTitle}
      />
      <Box direction="horizontal" flexWrap="wrap" style={styles.palette}>
        {palette.map((paletteColor) => {
          const selected = paletteColor === selectedColor;

          return (
            <Pressable
              accessibilityLabel={`Choose ${paletteColor}`}
              accessibilityRole="button"
              accessibilityState={{ selected }}
              key={paletteColor}
              onPress={() => {
                selectionAsync();
                onChangeColor(paletteColor);
              }}
              styleOverride={({ pressed }) =>
                styles.swatch(paletteColor, selected, pressed)
              }
              testID="ColorPickerItem"
            >
              {selected ? (
                <Icon
                  color={getOffsetColor(paletteColor, true)}
                  name="checkmark"
                  size="md"
                />
              ) : null}
            </Pressable>
          );
        })}
      </Box>
    </FieldCard>
  );
}

const styles = StyleSheet.create((theme) => ({
  palette: {
    gap: theme.size(1.5),
  },
  swatch: (color: string, selected: boolean, pressed: boolean) => ({
    alignItems: 'center',
    backgroundColor: color,
    borderColor: selected ? theme.colors.typography : theme.colors.borderMuted,
    borderRadius: theme.borderRadius.full,
    borderWidth: selected ? theme.size(0.75) : theme.size(0.5),
    height: theme.size(7),
    justifyContent: 'center',
    opacity: pressed ? 0.7 : 1,
    width: theme.size(7),
    _web: {
      _hover: {
        opacity: 0.8,
      },
    },
  }),
}));
